define.alias("shared/components/shared/carousel/index", "settings/components/shared/carousel/index");